// Always-mounted (in DashboardLayout) situational-awareness bridge. Renders nothing — it just runs
// the bridge hook so SAM can read the current page/mode/view from any page. See useUIContextBridge.
import React from 'react';
import { useUIContextBridge } from '@/hooks/useUIContextBridge';

const UIContextBridge: React.FC = () => {
  useUIContextBridge();
  return null;
};

export default UIContextBridge;
